export default "__VITE_ASSET__DKzrmSJZ__"